export default "__VITE_ASSET__DB5YiAwQ__"